//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import portal from '~/net/portal';

export default {
  name: 'News',
  head() {
    return {
      title: '资讯' + '-江苏技术产权交易市场',
    };
  },
  data() {
    return {
      routes: [{ name: '首页', path: '/' }, { name: '资讯' }],
      selectedCarousel: 0,
      setting: {
        autoplay: true,
        autoplaySpeed: 2000,
        dots: 'inside',
        radiusDot: true,
        trigger: 'hover',
        arrow: 'never',
      },
    };
  },
  async asyncData({ app }) {
    const [resp1, banner, informationList] = await Promise.all([
      app.$api.getTopInformation({ num: 6 }),
      app.$api.getBannerInformation({ num: 5 }),
      app.$api.getTopTypeInformation({
        typeNum: 4,
        infoNum: 5,
      }),
    ]);
    const data1 = resp1.data;
    return {
      topNews: data1,
      bannerList: banner.data,
      informations: informationList.data,
    };
  },
};
